import './BouncyText.scss';

interface BouncyTextProps {
    text: string;
    className?: string;
}

const BouncyText = (props: BouncyTextProps) => {
    return (
        <span className={`bouncy-text ${props.className || ''}`} aria-label={props.text}>
            {Array.from(props.text).map((ch, i) => (
                <span
                    key={`${ch}-${i}`}
                    className={`bouncy-letter`}
                    style={{ ["--i" as any]: i }}
                    aria-hidden="true"
                >
                    {ch === " " ? "\u00A0" : ch}
                </span>
            ))}
        </span>
    );
};

export default BouncyText;